
<template>
  <div>
    <router-view />
  </div>
</template>

<script setup>
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()

// 在组件挂载时初始化用户信息
onMounted(() => {
  userStore.initUserInfo()
})


</script>


<style scoped></style>
